export const MAX_LENGTH_ENTITY = {
  EVENT_MANAGER_NAME: 45,

  FIELD_SETTING_NAME: 45,
  FIELD_SETTING_VALUE: 45,

  THEME_NAME: 45,

  EVENT_NAME: 60,
  EVENT_WHAT: 100,
  EVENT_WHEN: 100,
  EVENT_WHERE: 100,
  EVENT_WHO: 100,
  EVENT_WHY: 100,
  EVENT_NOTE: 500,

  UF_USER_FIRSTNAME: 50,
  UF_USER_LASTNAME: 50,
  UF_USER_EMAIL: 150,
};